import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import CirclePlus from '../images/dbplus@3x.png'
import Modal from 'react-modal';
import AppointmentService from '../utils/AppointmentService.js';
import SpiffyMapIcon from '../images/mapIcon.png'
import HomeIcon from '../images/home.png'
import WorkIcon from '../images/business.png'
import LocationForm from "../Components/LocationForm.js"
import SelectRSL from "../Components/SelectRSL.js"
import SelectBuildings from "../Components/SelectBuildings.js"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, OverlayView } from "react-google-maps"
import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'
const { compose, withProps, lifecycle } = require("recompose");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const _ = require("lodash");
const google = window.google
const MapWithASearchBox = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD2mSKeIWHZpjASwcopmqGaWmkqqEgcf80&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div id='mapContainer' style={{ height: `92%` }} />,
    mapElement: <div id='map' style={{ height: `97%` }} />,

  }),
  lifecycle({
    componentDidMount() {
      this.state = {
        showAtWork: false
      };
      const refs = {}
      //var currentLocation = {lat: parseFloat(localStorage.getItem('lat')), lng: parseFloat(localStorage.getItem('lng'))}
      this.setState({
        center: {
          lat: this.props.location.lat, lng: this.props.location.lng,
        },
        position: {
          lat: this.props.location.lat, lng: this.props.location.lng,
        },
        onMapMounted: ref => {
          refs.map = ref;
        },
        onBoundsChanged: _.debounce(
          () => {
          this.setState({
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
            position: refs.map.getCenter()
          })
          let { onBoundsChange } = this.props
          if (onBoundsChange) {
            onBoundsChange(refs.map)
          }
          },
          50,
          { maxWait: 400 }
        ),
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        dragMap: ref => {
          var center = {
            lat: refs.map.getCenter().lat(),
            lng: refs.map.getCenter().lng()
          }

          this.setState({
            center: center,
            position: center
          })
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();

          const nextMarkers = places.map(place => ({
            position: place.geometry.location,
          }));
          const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
          this.setState({
            center: nextCenter,
            markers: nextMarkers,
            position: {lat: places[0].geometry.location.lat(), lng: places[0].geometry.location.lng()},
          });
        },
        onClick: ({ count }) => (
                    this.parentThis = this,
                     this.ApptService = new AppointmentService(),
                     this.setState({
                       showForm: false
                     }),
                     this.ApptService.rslBuildings(this.state.center.lat(), this.state.center.lng())
                     .then(res =>{
                           var buildings = []
                           buildings = res.locations
                           var showForm
                           if(buildings.length < 1){
                             showForm = true
                           }
                           else{
                             showForm = false
                           }
                           this.parentThis.setState({
                             buildings: res.locations,

                           }, function(){
                             document.getElementById('mapContainer').style.height = '50%'

                           });
                           return this
                           //document.getElementById('map').style.height = '50%'


                     }).then(function(parentThis){
                       parentThis.ApptService.addressFromCoords(parentThis.state.center.lat(), parentThis.state.center.lng())

                       .then(res =>{

                         if(res.results && res.results[0]){
                          if(parentThis.state.buildings && parentThis.state.buildings.length > 0){
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: true,
                             showForm: false,
                             thisProps: parentThis.props
                           })
                          }
                          else {
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: false,
                             showForm: true,
                             thisProps: parentThis.props
                            })
                          }
                          parentThis.props.onClick(parentThis.state.buildings, parentThis.state.showForm, parentThis.state.showAtWork, parentThis.state.mapAddress)

                         }
                       })
                      .catch(err => {
                        throw new Error('Error fetching addresses: ' + err.message);
                      });
                     })


                 ),
               })
             },
           }),
  withScriptjs,
  withGoogleMap,
)(props =>
  <div>
    <GoogleMap
      ref={props.onMapMounted}
      defaultZoom={15}
      center={props.center}
      onBoundsChanged={props.onBoundsChanged}
      defaultOptions={{
       // these following 7 options turn certain controls off see link below
        mapTypeControl: false,
        fullscreenControl: false
      }}
    >
      <SearchBox
        ref={props.onSearchBoxMounted}
        controlPosition={google.maps.ControlPosition.TOP_LEFT}
        onPlacesChanged={props.onPlacesChanged}
      >
        <input
          type="text"
          placeholder="Search for your address..."
          style={{
            boxSizing: `border-box`,
            border: `1px solid transparent`,
            width: `50%`,
            height: `32px`,
            marginTop: `27px`,
            marginLeft: `25%`,
            padding: `0 12px`,
            borderRadius: `3px`,
            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`,
          }}
        />
      </SearchBox>
        <Marker
          position={props.position}
          icon={SpiffyMapIcon}
          >
        </Marker>
        <OverlayView
          position={props.position}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div style={{ background: `white`, border: `1px solid #ccc`, padding: 0 }}>
            <button className="btn" onClick={props.onClick} style={{ color: 'white', backgroundColor: '#5BBA76', width: 80, height: 40 }}>
              Confirm
            </button>
          </div>
        </OverlayView>
    </GoogleMap>
  </div>
);
const MapImage = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD2mSKeIWHZpjASwcopmqGaWmkqqEgcf80&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div id='mapContainer2' style={{ height: `200px` }} />,
    mapElement: <div id='map' style={{ height: `97%` }} />,

  }),
  lifecycle({
    componentDidMount() {
      this.state = {
        showAtWork: false
      };
      const refs = {}
      //var currentLocation = {lat: parseFloat(localStorage.getItem('lat')), lng: parseFloat(localStorage.getItem('lng'))}
      this.setState({
        center: {
          lat: this.props.location.lat, lng: this.props.location.lng,
        },
        position: {
          lat: this.props.location.lat, lng: this.props.location.lng,
        },
        onMapMounted: ref => {
          refs.map = ref;
        },
        onBoundsChanged: _.debounce(
          () => {
          this.setState({
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
            position: refs.map.getCenter()
          })
          let { onBoundsChange } = this.props
          if (onBoundsChange) {
            onBoundsChange(refs.map)
          }
          },
          50,
          { maxWait: 400 }
        ),
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        dragMap: ref => {
          var center = {
            lat: refs.map.getCenter().lat(),
            lng: refs.map.getCenter().lng()
          }

          this.setState({
            center: center,
            position: center
          })
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();

          const nextMarkers = places.map(place => ({
            position: place.geometry.location,
          }));
          const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
          this.setState({
            center: nextCenter,
            markers: nextMarkers,
            position: {lat: places[0].geometry.location.lat(), lng: places[0].geometry.location.lng()},
          });
        },
        onClick: ({ count }) => (
                    this.parentThis = this,
                     this.ApptService = new AppointmentService(),
                     this.setState({
                       showForm: false
                     }),
                     this.ApptService.rslBuildings(this.state.center.lat(), this.state.center.lng())
                     .then(res =>{
                           var buildings = []
                           buildings = res.locations
                           var showForm
                           if(buildings.length < 1){
                             showForm = true
                           }
                           else{
                             showForm = false
                           }
                           this.setState({
                             buildings: res.locations,

                           }, function(){
                             document.getElementById('mapContainer').style.height = '50%'

                           });
                           return this
                           //document.getElementById('map').style.height = '50%'


                     }).then(function(parentThis){
                       parentThis.ApptService.addressFromCoords(parentThis.state.center.lat(), parentThis.state.center.lng())

                       .then(res =>{
                         if(res.results && res.results[0]){
                          if(parentThis.state.buildings && parentThis.state.buildings.length > 0){
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: true,
                             showForm: false,
                             thisProps: parentThis.props
                           })
                          }
                          else {
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: false,
                             showForm: true,
                             thisProps: parentThis.props
                            })
                          }
                          parentThis.props.onClick(parentThis.state.buildings, parentThis.state.showForm, parentThis.state.showAtWork, parentThis.state.mapAddress)

                         }
                       })
                      .catch(err => {
                        throw new Error('Error fetching addresses: ' + err.message);
                      });
                     })


                 ),
               })
             },
           }),
  withScriptjs,
  withGoogleMap,
)(props =>
  <div>
    <GoogleMap
      ref={props.onMapMounted}
      defaultZoom={15}
      center={props.center}
      onBoundsChanged={props.onBoundsChanged}
      defaultOptions={{
        scrollwheel: false,
       // these following 7 options turn certain controls off see link below
        mapTypeControl: false,
        fullscreenControl: false
      }}
    >
        <Marker
          position={props.position}
          icon={SpiffyMapIcon}
          >
        </Marker>
        <OverlayView
          position={props.position}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
        </OverlayView>
    </GoogleMap>
  </div>
);
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

export class LocationEdit extends Component {
  constructor(props) {
    super(props)

    this.ApptService = new AppointmentService()
    this.state = {
      location: props.location,
      showConfirmationModal: false,
      editLocationModal: false,
      showAtWork: false,
      showBuildings: false,
      showForm: false,
      showButton: false,
    };
    this.updateDimensions = this.updateDimensions.bind(this)
    this.showModal = this.showModal.bind(this)
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    if(this.props.selectedVehicle && document.getElementById("vehicle"+ this.props.selectedVehicle.id)){
      document.getElementById("vehicle"+ this.props.selectedVehicle.id).style.backgroundColor = "#ff8c00"
    }
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  showModal(){
    this.setState({
      showConfirmationModal: true
    })
  }
  closeConfirmationModal() {
    this.setState({
      showConfirmationModal: false
    })
  }
  editLocation = () => {
    this.setState({
      editLocationModal: true
    })
  }
  closeModal = () => {
    this.setState({
      editLocationModal: false
    })
  }
  deleteAddress = () => {
    this.ApptService.hideAddress(this.state.location.id)
    .then(res => {
        if(res && res.errors)
        {
            this.props.setError(res.errors)
        }
      this.props.reloadAddresses()
      this.setState({
        showConfirmationModal: false
      })
    })
    .catch(err => {

    })
  }
  saveAddress =(location) => {
    this.setState({
      location:location
    })
    this.closeModal()
  }
  handleChildClick = (buildings, showForm, showAtWork, mapAddress) => {
    this.setState({
      showAtWork: false,
      showForm:true,
      mapAddress: mapAddress,
      showButton: false
    });
  }
  render() {
    const modalStyle =
    this.state.width < 780 ?
    {
      content: {
        top                   : '22.5%',
        left                  : '0%',
        height                : '55%',
        width                 : '100%',
        padding               : '10px',
        right                 : 'auto',
        backgroundColor       : '#134270',
        color                 : 'white',
      }
    }:
      {
        content: {
          top                   : '22.5%',
          left                  : '30%',
          height                : '55%',
          width                 : '40%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : '#134270',
          color                 : 'white',
        }
      }
      const modalStyle2 =
      this.state.width < 780 ?
      {
        content: {
          top                   : '30%',
          left                  : '0%',
          height                : '40%',
          width                 : '100%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : 'white',
          color                 : 'black',
        }
      }:
        {
          content: {
            top                   : '30%',
            left                  : '35%',
            height                : '40%',
            width                 : '30%',
            padding               : '10px',
            right                 : 'auto',
            backgroundColor       : 'white',
            color                 : 'black',
          }
        }
    const customStyle = {
          content: {
            backgroundColor: '#253D59',
            top                   : '0%',
            left                  : '0%',
            height                : '100%',
            width                 : '100%',
          }
    }
    var vehicleType = 'sedan'
    var location = this.state.location
    return (
      <div>
        {this.state.location &&
          <div className="locationCard">
            <MapImage location={this.state.location} />
            <div className="flexContainer">
              { location.rdi == 'Commercial' &&
                <img className="mr-3 list-icon editImageIcon" src={WorkIcon}></img>
              }
              {location.rdi == 'Residential' &&
                <img className="mr-3 list-icon editImageIcon" src={HomeIcon}></img>
              }
            <div>{location.display_title}<br></br>{location.street}</div>
            </div>
            <div className ="flexContainer">
                {!location.edit_locked && <button onClick = {() => this.editLocation()} className="btn successButtonFlex btn-block text-center" type="submit">Edit</button>}
              <button onClick = {() => this.showModal()}className="btn btn-block cancelButtonFlex text-center">Delete</button>
            </div>
          </div>
        }
        <Modal
          style={modalStyle2}
          isOpen={this.state.showConfirmationModal}
          contentLabel="Example Modal">
          <h2 className="modalHeader">Remove Location?</h2>
          <p>You are about to delete this location From your account, are you sure you want to do this?</p>
          <div className="bottomButtons">
            <button onClick = {() => this.deleteAddress()} className="btn successButtonFlex btn-block text-center" type="submit">Confirm</button>
            <button onClick = {() => this.closeConfirmationModal()}className="btn btn-block cancelButtonFlex text-center">Cancel</button>
          </div>
        </Modal>
        <Modal
          style={customStyle}
          isOpen={this.state.editLocationModal}
          contentLabel="Example Modal">
          <MapWithASearchBox location = {this.state.location} onClick = {this.handleChildClick}/>
           {this.state.showAtWork ? <SelectRSL key = {1} saveBuildings = {this.saveBuildings} showForm={this.showForm} buildings={this.state.buildings}/>:null}
           {this.state.showForm ? <LocationForm key = {1} locationId={this.state.location.id} selectLocation={this.saveAddress} closeModal={this.closeModal} address={this.state.mapAddress} setError = {this.props.setError}/>: null}
          {this.state.showBuildings ? <SelectBuildings key = {1}  selectLocation={this.selectLocation}  closeModal={this.closeModal} showForm={this.showForm} buildings={this.state.specificBuildings}/>: null}
           {this.state.showButton ? <button id="newLocation" onClick = {this.newLocationClick}>Enter New Location</button>: null }
           <button onClick = {() => this.closeModal()}className="btn btn-block text-center redButton">Cancel</button>
        </Modal>
        </div>
    )
  }
}
export default LocationEdit



// WEBPACK FOOTER //
// ./src/Components/LocationEdit.js